import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import ProductsBlock from "../../Components/Products";
import PageHeader from "../../Components/Common/PageHeader";
import "./style.scss";

const STORAGE_KEY = "products_selected_workspace";

const ProductsPage = () => {
  const [workspaces, setWorkspaces] = useState([]);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ""
  );
  const [loadingWorkspaces, setLoadingWorkspaces] = useState(true);

  useEffect(() => {
    Utils.setPageTitle("Products");
  }, []);

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const response = await Utils._apiRequest({
          path: Enums.endpoints.workspace.ALL,
          type: "GET",
          query: { page: 1, limit: 100 },
        });
        setWorkspaces(response.data || []);

        if (selectedWorkspaceId && response.data) {
          const exists = response.data.some(
            (ws) => ws._id === selectedWorkspaceId
          );
          if (!exists) {
            setSelectedWorkspaceId("");
            localStorage.removeItem(STORAGE_KEY);
          }
        }
      } catch (error) {
        console.log("Failed to fetch workspaces:", error.message);
      } finally {
        setLoadingWorkspaces(false);
      }
    };

    fetchWorkspaces();
  }, []);

  const handleWorkspaceChange = (e) => {
    const value = e.target.value;
    setSelectedWorkspaceId(value);
    if (value) {
      localStorage.setItem(STORAGE_KEY, value);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="Products"
          description="Quản lý nguồn sản phẩm để import vào WooCommerce / Shopify"
          icon={faBoxOpen}
        />

        <section className="products-workspace-card mb-4">
          <Row className="g-3 align-items-end">
            <Col md={7} lg={8}>
              <div className="products-workspace-copy">
                <span className="products-kicker">Workspace Context</span>
                <h5>Chọn workspace để quản lý</h5>
                <p>
                  Sản phẩm và category được lưu theo workspace. Hiện tại đang hỗ trợ
                  nguồn Etsy, có thể mở rộng thêm nguồn khác sau này.
                </p>
              </div>
            </Col>
            <Col md={5} lg={4}>
              <Form.Group>
                <Form.Label className="fw-semibold">Chọn Workspace</Form.Label>
                <Form.Select
                  value={selectedWorkspaceId}
                  onChange={handleWorkspaceChange}
                  disabled={loadingWorkspaces}
                >
                  <option value="">
                    {loadingWorkspaces
                      ? "Đang tải workspace..."
                      : "-- Chọn workspace --"}
                  </option>
                  {workspaces.map((ws) => (
                    <option key={ws._id} value={ws._id}>
                      {ws.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </section>

        {selectedWorkspaceId ? (
          <ProductsBlock workspaceId={selectedWorkspaceId} />
        ) : (
          <div className="text-muted text-center py-5">
            Vui lòng chọn một workspace để bắt đầu.
          </div>
        )}
      </div>
    </main>
  );
};

export default ProductsPage;
